<div class="flex-row">
  <mat-icon [matMenuTriggerFor]="menu" color="primary">language</mat-icon>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="setLanguage('pl')"><span class="flag-icon margin-right-5 flag-icon-pl"></span> Polski</button>
    <button mat-menu-item (click)="setLanguage('en')"><span class="flag-icon margin-right-5 flag-icon-gb"></span> English</button>
  </mat-menu>
</div>
